import React, { useEffect, useState } from "react";
import "./Login.css";
import login_img from "../../asserts/login_img.jpeg";
import { LoginUser, clearAuthError } from "../../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getDefaultRouteForRole } from "../../utils/roleAccess";
const Login = () => {
  const { loading, error, isAuthenticated, user } = useSelector(
    (state) => state.authState
  );
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { value, name } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(LoginUser(loginData));
  };
  useEffect(() => {
    if (error) {
      toast(error, {
        type: "error",
        onOpen: () => {
          dispatch(clearAuthError);
        },
      });
      return;
    }
    if (isAuthenticated) {
      navigation(getDefaultRouteForRole(user?.role));
    }
  }, [dispatch, error, isAuthenticated, navigation, user?.role]);
  return (
    <div className="login">
      <div className="login_container">
        <div className="login_left">
          <h1>Login</h1>
        </div>
        <img src={login_img} alt="" />
        <div className="login_right">
          <div className="login_right_container">
            <form className="login_form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Username"
                name="email"
                value={loginData.email}
                onChange={handleChange}
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={loginData.password}
                onChange={handleChange}
              />
              <input
                type="submit"
                value={"submit"}
                className="button"
                disabled={loading}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
